// For now this is a very simple check to see if BigCommerce has injected
// the window.checkoutConfig, but may be expanded in the future

export var isOrderConfirmationPage = function isOrderConfirmationPage() {
  return !window.checkoutConfig;
};
// export const isOrderConfirmationPage = () => true;